export const ROLES = {
  ADMIN: "admin",
  MEMBER: "member",
};

export function resolveRole(user) {
  if (!user) return null;
  return (user.publicMetadata?.role ?? user.publicMetadata?.user_role) === ROLES.ADMIN ? ROLES.ADMIN : ROLES.MEMBER;
}

export function roleLabel(role) {
  return role === ROLES.ADMIN ? "Admin" : "Member";
}

export function buildRoleContext(user, viewAsRole, setViewAsRole) {
  const actualRole = resolveRole(user)
  const isAdmin = actualRole === ROLES.ADMIN;

  return {
    user,
    actualRole,
    isAdmin,
    isViewingAs: isAdmin && viewAsRole !== null && viewAsRole !== actualRole,
    setCurrentRole: isAdmin ? setViewAsRole : undefined,
  };
}